module.exports = __webpack_public_path__ + "static/media/pa.ede03811.svg";